/** Joins the selected answer-length text and effective instruction in send order. */
export function composeInstruction(
    answerLengthInstruction?: string | null,
    resolvedInstruction?: string | null,
): string {
    return [answerLengthInstruction, resolvedInstruction]
        .filter((value): value is string => typeof value === "string" && value.length > 0)
        .join("\n\n");
}

export function instructionLength(value: string): number {
    return Array.from(value).length;
}
